// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__31603","h1":"styles_h1__32aDP","p":"styles_p__VhEsQ","i":"styles_i__3Qqsd","card":"styles_card__dhDPt"};